import BFFApi from '../utils/bffApi';

const TradeAdsService = {
  postReplicateAds(data) {
    return BFFApi.post('/api/v1/media/replicate-ad', data);
  },
};

export default TradeAdsService;
